import Axios from "axios";
import {
  SET_BONUS_SUMMARY_REGISTER_REPORT_LIST,
  UNSET_BONUS_SUMMARY_REGISTER_REPORT_LIST,
} from "@/store/mutation-types";
import {
  getBonusSummaryRegisterReport,
} from "@/store/api";

const state = {
  getBonusSummaryRegisterReport: [],
};

const getters = {
  getBonusSummaryRegisterReport(state) {
    return state.getBonusSummaryRegisterReport;
  },
};

const mutations = {
  [SET_BONUS_SUMMARY_REGISTER_REPORT_LIST](state, data) {
    state.getBonusSummaryRegisterReport = data;
  },
  [UNSET_BONUS_SUMMARY_REGISTER_REPORT_LIST](state) {
    state.getBonusSummaryRegisterReport = [];
  },
};

const actions = {
  getBonusSummaryRegisterReport({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(`${getBonusSummaryRegisterReport}`, { params: data })
        .then((response) => {
          commit(SET_BONUS_SUMMARY_REGISTER_REPORT_LIST, response.data.data);
          resolve(response);
        })
        .catch((error) => {
          commit(UNSET_BONUS_SUMMARY_REGISTER_REPORT_LIST);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

